<template>
	<div class="navigation-desktop">
		<div class="right">
			<router-link to="/">
				<img class="logo" src="@/assets/logo.svg" alt="" />
			</router-link>
		</div>
		<ul class="left">
			<router-link
				to="/"
				tag="li"
				v-bind:class="{ active: $route.path == '/' }"
			>
				<div v-if="$route.path == '/'" class="point"></div>
				<div class="ch">首頁</div>
				<div class="en">Home</div>
			</router-link>
			<li v-bind:class="{ active: $route.path.indexOf('about') != -1 }">
				<div v-if="$route.path.indexOf('about') != -1" class="point"></div>
				<div class="ch">關於偶戲村</div>
				<div class="en">About</div>
				<ul class="sub-menu">
					<router-link
						to="/about"
						tag="li"
						v-bind:class="{ active: $route.path == '/about' }"
					>
						關於「利澤國際偶戲藝術村」<br />
						About Lìzé Puppet Art Colony
					</router-link>
					<!-- <router-link to="/about/info" tag="li" v-bind:class="{active:($route.path=='/about/info')}">
						參觀資訊<br> Visiting Information
					</router-link> -->
					<router-link
						to="/about/corner"
						tag="li"
						v-bind:class="{ active: $route.path == '/about/corner' }"
					>
						空間介紹<br />
						Spaces
					</router-link>
					<router-link
						to="/about/environment"
						tag="li"
						v-bind:class="{ active: $route.path == '/about/environment' }"
					>
						周邊環境介紹<br />
						About “Lìzé”
					</router-link>
					<router-link
						to="/about/report"
						tag="li"
						v-bind:class="{ active: $route.path == '/about/report' }"
					>
						交通資訊<br />
						Getting Here
					</router-link>
				</ul>
			</li>
			<li v-bind:class="{ active: $route.path.indexOf('event') != -1 }">
				<div v-if="$route.path.indexOf('event') != -1" class="point"></div>
				<div class="ch">展演活動</div>
				<div class="en">Events</div>
				<ul class="sub-menu">
					<router-link
						to="/event/list"
						tag="li"
						v-bind:class="{ active: $route.path == '/event/list' }"
					>
						活動回顧<br />
						Event Review
					</router-link>
					<router-link
						to="/event/news"
						tag="li"
						v-bind:class="{ active: $route.path == '/event/news' }"
					>
						最新消息<br />
						News
					</router-link>
				</ul>
			</li>
			<li v-bind:class="{ active: $route.path.indexOf('program') != -1 }">
				<div v-if="$route.path.indexOf('program') != -1" class="point"></div>
				<div class="ch">駐村計畫</div>
				<div class="en">Artist-in-Residence</div>
				<ul class="sub-menu">
					<router-link
						to="/program/apply"
						tag="li"
						v-bind:class="{ active: $route.path == '/program/apply' }"
					>
						駐村藝術家計畫<br />
						Program Application
					</router-link>
					<router-link
						to="/program/list"
						tag="li"
						v-bind:class="{ active: $route.path == '/program/list' }"
					>
						駐村藝術家列表<br />
						Artists
					</router-link>
					<router-link
						to="/program/activities"
						tag="li"
						v-bind:class="{ active: $route.path == '/program/activities' }"
					>
						駐村活動<br />
						AIR Activities
					</router-link>
				</ul>
			</li>
			<li v-bind:class="{ active: $route.path.indexOf('reservation') != -1 }">
				<div
					v-if="$route.path.indexOf('reservation') != -1"
					class="point"
				></div>
				<div class="ch">活動預約</div>
				<div class="en">Reservation</div>
				<ul class="sub-menu">
					<!-- <router-link to="/reservation/secret" tag="li" v-bind:class="{active:($route.path=='/reservation/secret')}">
						預約「操偶師職人實境體驗」<br> Guided Tour
					</router-link> -->
					<router-link
						to="/reservation/play"
						tag="li"
						v-bind:class="{ active: $route.path == '/reservation/play' }"
					>
						參訪與客製活動<br />
						Visit Colony
					</router-link>
					<li class="router-link">
						<a
							href="https://lizepuppet.oen.tw/"
							target="_blank"
							rel="noopener"
							style="color: #fff;text-decoration: none;"
							>近期活動 <br>
							Upcoming Events</a
						>
					</li>
				</ul>
			</li>
			<router-link
				to="/rent"
				tag="li"
				v-bind:class="{ active: $route.path == '/rent' }"
			>
				<div v-if="$route.path == '/rent'" class="point"></div>
				<div class="ch">場地租借</div>
				<div class="en">Rental</div>
			</router-link>
			<li v-bind:class="{ active: $route.path.indexOf('support') != -1 }">
				<div v-if="$route.path.indexOf('support') != -1" class="point"></div>
				<div class="ch">支持我們</div>
				<div class="en">Support us</div>
				<ul class="sub-menu">
					<router-link
						to="/support/team"
						tag="li"
						v-bind:class="{ active: $route.path == '/support/team' }"
					>
						超偶特攻隊<br />
						Volunteer
					</router-link>
					<router-link
						to="/support/club"
						tag="li"
						v-bind:class="{ active: $route.path == '/support/club' }"
					>
						偶迷俱樂部<br />
						Membership
					</router-link>
				</ul>
			</li>
			<li>
				<a
					href="https://sites.google.com/view/academyofpuppetart/"
					target="_blank"
					class="ch"
					style="color:#636363;text-decoration: none;"
					><div class="ch" style="margin-bottom: 3px;">國際偶戲</div>
					<div class="ch">職人學校</div>
					</a
				>
			</li>
			<li>
				<a
					href="https://www.pinkoi.com/store/llizepuppet"
					target="_blank"
					class="ch"
					style="color: #fff; background: #01b6e2; padding: 5px"
					>玩偶小舖</a
				>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "navigation-desktop",
	data() {
		return {
			activeIndex: 1,
		};
	},
	methods: {
		mouseOver: function () {
			this.active = !this.active;
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../stylesheet/base.sass'
@import '../stylesheet/layout.sass'

.navigation-desktop
  +flexLayout('between', 'row')
  z-index: 9999999999
  width: 100%
  padding: 10px 18px
  box-sizing: border-box
  position: fixed
  top: 0
  right: 0
  background-color: white
  border-bottom-width: 1px
  border-bottom-style: solid
  border-bottom-color: #01b6e2
  .right
    .logo
      +size(152px, 36px)
  .left
    +flexLayout('between', 'row')
    align-items: flex-start
    color: $unselect
    li
      +flexLayout('center', 'col')
      padding: 12px 6px 12px 6px
      cursor: pointer
      position: relative
      .ch
        font-size: 14px
      .en
        margin-top: 5px
        font-size: 12px
        text-align: center
      &:hover
        color: $select
        .sub-menu
          +flexLayout('start', 'col')

      &.active
        color: $select
        //font-weight: 700
      .sub-menu
        display: none
        +size(250px, initial)
        background-color: $themeColor
        position: absolute
        font-size: 12px
        top: 50px
        left: 15px
        text-align: left
        padding: 18px
        box-sizing: border-box
        z-index: 1001
        &:hover
          +flexLayout('start', 'col')
          opacity: 1
        li
          color: white
          opacity: 0.9
          margin: 0
          padding: 0
          margin-top: 14px
          cursor: pointer
          line-height: 1.4
          &:nth-child(1)
            margin: 0
            margin-top: 0px
          &:hover
            opacity: 1
            font-weight: 700
          &.active
            opacity: 1
            font-weight: 700
      &:last-child
        .sub-menu
          right: 0px
          left: initial
    .point
      width: 8px
      height: 8px
      transform: rotate(45deg)
      border-radius: 2px
      background-color: #01b6e2
      position: absolute
      top: 0px
</style>



// WEBPACK FOOTER //
// src/components/navigation_desktop.vue